import { useState } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { dictionariesApi } from '@api/dictionariesApi';
import { useDebouncedValue } from '@hooks/useDebouncedValue';

interface ProductSearchSelectProps {
  value?: string;
  onChange?: (mdProductId: string) => void;
  placeholder?: string;
}

/**
 * Вибір номенклатури через серверний пошук GET /products/search (SKU, назва, GTIN; до 50 позицій).
 * Список не залежить від залишків — інакше товар, якого ще немає на складі, неможливо оприбуткувати,
 * а сторінка залишків обмежена 100 рядками.
 */
export default function ProductSearchSelect({ value, onChange, placeholder }: ProductSearchSelectProps) {
  const [mdSearchText, setMdSearchText] = useState('');
  const mdDebouncedSearch = useDebouncedValue(mdSearchText.trim());

  const { data: mdProducts, isFetching: mdIsFetching } = useQuery({
    queryKey: ['dictionaries', 'products', 'search-select', mdDebouncedSearch],
    queryFn: () => dictionariesApi.searchProducts(mdDebouncedSearch),
    placeholderData: (mdPreviousData) => mdPreviousData,
  });

  return (
    <Select
      showSearch
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? 'Пошук за SKU, назвою або GTIN...'}
      filterOption={false}
      onSearch={setMdSearchText}
      notFoundContent={mdIsFetching ? <Spin size="small" /> : 'Нічого не знайдено'}
      options={(mdProducts ?? []).map((mdProduct) => ({
        value: mdProduct.id,
        label: `${mdProduct.sku} — ${mdProduct.name}`,
      }))}
    />
  );
}
